import { useEffect, useState } from 'react';
import styled from 'styled-components';

export const CallSupport = ({ showCrm, setShowCrm }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setInnerHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Wrapper hidden={showCrm && innerHeight < 520}>
      <div onClick={() => setShowCrm(true)} className="call_Support">
        تماس با پشتیبانی
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .call_Support {
    display: ${({ hidden }) => (hidden ? 'none' : 'block')};
    position: absolute;
    bottom: 16px;
    left: 17px;
    font-weight: 400;
    font-size: 14px;
    color: #707070;
    text-align: left;
  }
`;
